import { module } from 'stereomodularjs';

export default class extends module {
	constructor(m) {
		super(m);
	}

	init() {

		// debug focus
		// document.addEventListener('focusin', function() {
		//     console.log('focused: ', document.activeElement)
		// }, true);

		// c-header-navtoggle on click, remove -is-children-active on all -has-children 
		Array.from(document.querySelectorAll('.c-header-navtoggle')).forEach(toggle => {
			toggle.addEventListener('click', function (e) {
				Array.from(document.querySelectorAll('.c-nav-overlay__item.-has-children.-is-children-active')).forEach(li => {
					li.classList.remove('-is-children-active');
				}
				);
			});
		});

		// Get all parents
		var getParents = function (elem, selector) {
			// Setup parents array
			var parents = [];
			// Get matching parent elements
			while (elem && elem !== document) {
				// If using a selector, add matching parents to array
				// Otherwise, add all parents
				if (selector) {
					if (elem.matches(selector)) {
						parents.push(elem);
					}
				} else {
					parents.push(elem);
				}
				// Jump to the next parent node
				elem = elem.parentNode;
			}
			return parents;
		};

		// NAV CLASS CLEANING & ACTIVE
		Array.from(document.querySelectorAll('.c-nav-link')).forEach(a => {
			a.parentNode.classList.remove('is-active', '-is-ancestor', '-is-current')
		});
		if (location.pathname != '/') {
			Array.from(document.querySelectorAll('.c-nav-link')).forEach(a => {
				if (location.href === a.href) {
					a.parentNode.classList.add('-is-current');
					// Get all parents with .c-nav-li class
					var navLi = getParents(a, '.c-nav-li');
					if (navLi.length) {// If there's any
						navLi.forEach(function (elm) {
							//Add class ancestor
							elm.classList.add('-is-ancestor');
						});
					}
				}
			});
		}

		// NAV OVERLAY MANAGE SUBNAV
		Array.from(document.querySelectorAll('.c-nav-overlay__item.-has-children > .c-nav-overlay__link')).forEach(lnk => {
			lnk.addEventListener('click', function (e) {
				// Stop link redirection
				e.preventDefault();
				e.stopImmediatePropagation();

				// Remove active class on all parents
				if (!lnk.parentNode.classList.contains('-is-children-active')) {
					Array.from(document.querySelectorAll('.c-nav-overlay__item.-has-children.-is-children-active')).forEach(li => {
						li.classList.remove('-is-children-active');
					});
				}

				// Toggle active class on parent
				lnk.parentNode.classList.toggle('-is-children-active');
			}, true);
		});

		/*
		// WRAP IFRAME INSIDE WP CONTENT
		let iframes = document.querySelectorAll('.o-text > p > iframe');
		if(iframes.length){
			Array.prototype.forEach.call(iframes, function (entry, i) {
				var originalIframe = entry.parentNode.innerHTML;
				let newWrapper = '<span class="c-iframe__wrapper">' + originalIframe + '</span>';
				entry.parentNode.innerHTML = newWrapper;
			});
		}
		*/
	}
}
